export enum DomonetizationGroupsEnum {
  MONTH = "MONTH",
  WEEK = "WEEK",
  DAY = "DAY",
  CREATIVE_ID = "CREATIVE_ID",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  DOMONETIZATION_CATEGORIES = "DOMONETIZATION_CATEGORIES",
  DOMONETIZATION_WEBMASTER = "DOMONETIZATION_WEBMASTER",
  DOMONETIZATION_OFFER = "DOMONETIZATION_OFFER",
  OFFER = "OFFER",
  OFFER_CATEGORIES = "OFFER_CATEGORIES",
  DOMONETIZATION_MANAGER = "DOMONETIZATION_MANAGER"
}